import { Component, OnInit } from '@angular/core';
import { User } from 'thkee-common';
import { DataTableComponent } from '../../../../@shared/components/data-table/data-table.component';
import { RouterLink } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { formatDatePipe } from '../../../../../../../thkee-common/src/lib/pipes/date.pipe';

let dummyData: User[] = [
  {
    id: '46',
    handle: 'administration-thkee',
    instructor: {
      id: 109,
      // user: 46,
      // instructor_consent: {
      //   video_pro: 'I’m a beginner',
      //   agree_the_terms: true,
      //   have_an_audience: 'Not at the moment',
      //   kind_of_teaching: 'In Person Informally',
      // },
      date_created: '2023-05-12T15:27:52.809181Z',
      // date_updated: '2023-08-08T12:33:32.483299Z',
    },
    first_name: 'Frank',
    last_name: 'Canlas',
    email: 'sample@thkee.com',
    headline: '',
    bio: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sitaspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
    photo: '',
    language: 'en',
    languages: {},
    stats: {
      classes: ['223', '223', '223', '220', '220', '220', '220', '316', '223', '346', '358', '310', '354', '356', '357'],
      courses: 10,
      published_courses: 5,
      students: 1,
      ratings: 54.0,
    },
    balance: 0,
    paypal_email: '',
    profile_completion: '5/8',
    date_created: '2023-05-12T15:27:52.809181Z',
    date_updated: '2023-05-12T15:27:52.809181Z',
  },
  {
    id: '46',
    handle: 'administration-thkee',
    instructor: {
      id: 109,
      // user: 46,
      // instructor_consent: {
      //   video_pro: 'I’m a beginner',
      //   agree_the_terms: true,
      //   have_an_audience: 'Not at the moment',
      //   kind_of_teaching: 'In Person Informally',
      // },
      date_created: '2023-05-12T15:27:52.809181Z',
      // date_updated: '2023-08-08T12:33:32.483299Z',
    },
    first_name: 'Frank',
    last_name: 'Two',
    email: 'frank2@thkee.com',
    headline: '',
    bio: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sitaspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
    photo: '',
    language: 'en',
    languages: {},
    stats: {
      classes: ['223', '223', '223', '220', '220', '220', '220', '316', '223', '346', '358', '310', '354', '356', '357'],
      courses: 11,
      published_courses: 6,
      students: 1,
      ratings: 54.0,
    },
    balance: 0,
    paypal_email: '',
    profile_completion: '11/11',
    date_created: '2023-05-12T15:27:52.809181Z',
    date_updated: '2023-05-12T15:27:52.809181Z',
  },
  {
    id: '46',
    handle: 'administration-thkee',
    instructor: {
      id: 109,
      // user: 46,
      // instructor_consent: {
      //   video_pro: 'I’m a beginner',
      //   agree_the_terms: true,
      //   have_an_audience: 'Not at the moment',
      //   kind_of_teaching: 'In Person Informally',
      // },
      date_created: '2023-05-12T15:27:52.809181Z',
      // date_updated: '2023-08-08T12:33:32.483299Z',
    },
    first_name: 'Frank',
    last_name: 'Three',
    email: 'frank3@thkee.com',
    headline: '',
    bio: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sitaspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
    photo: '',
    language: 'en',
    languages: {},
    stats: {
      classes: ['223', '223', '223', '220', '220', '220', '220', '316', '223', '346', '358', '310', '354', '356', '357'],
      courses: 20,
      published_courses: 14,
      students: 1,
      ratings: 54.0,
    },
    balance: 0,
    paypal_email: '',
    profile_completion: '8/11',
    date_created: '2023-05-12T15:27:52.809181Z',
    date_updated: '2023-05-12T15:27:52.809181Z',
  },
  {
    id: '46',
    handle: 'administration-thkee',
    instructor: {
      id: 109,
      // user: 46,
      // instructor_consent: {
      //   video_pro: 'I’m a beginner',
      //   agree_the_terms: true,
      //   have_an_audience: 'Not at the moment',
      //   kind_of_teaching: 'In Person Informally',
      // },
      date_created: '2023-05-12T15:27:52.809181Z',
      // date_updated: '2023-08-08T12:33:32.483299Z',
    },
    first_name: 'Frank',
    last_name: 'Four',
    email: 'frank4@thkee.com',
    headline: '',
    bio: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sitaspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
    photo: '',
    language: 'en',
    languages: {},
    stats: {
      classes: ['223', '223', '223', '220', '220', '220', '220', '316', '223', '346', '358', '310', '354', '356', '357'],
      courses: 8,
      published_courses: 3,
      students: 1,
      ratings: 54.0,
    },
    balance: 0,
    paypal_email: '',
    profile_completion: '5/11',
    date_created: '2023-05-12T15:27:52.809181Z',
    date_updated: '2023-05-12T15:27:52.809181Z',
  },
];

@Component({
    selector: 'app-member',
    templateUrl: './member.component.html',
    styleUrls: ['./member.component.scss'],
    imports: [DataTableComponent, RouterLink, AngularSvgIconModule, formatDatePipe]
})
export class InstructorGroupMemberComponent implements OnInit {
  title: string = 'Premium Instructor';
  memberData: User[] = dummyData;
  constructor() {}

  ngOnInit(): void {}

  computeDraft(total: any, publised: any) {
    return Number(total) - Number(publised);
  }
}
